<div class="ui segment"  appMargin marginB="3" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start stretch" >
	<div fxFlex="5%">
		   <sui-checkbox >
            </sui-checkbox>
	</div>
		<div fxFlex="15%">{{user?.name}}</div>
		<div fxFlex="25%">{{user?.email}}</div>
		<div fxFlex>{{user?.phone}}</div>
		<div fxFlex>{{user?.department}}</div>
			<div fxFlex><label class="ui circular green label">{{user?.status}}</label></div>
		<div fxFlex  class="text-right">
			<button class="ui circular tiny button" (click)="onDelete.emit(user)"><i class="trash icon"></i></button>
			<a class="ui circular tiny button" routerLink="/admin/setting/user/detail/{{user.id}}"><i class="eye icon"></i></a>
		</div>
</div>